export default __webpack_public_path__ + "assets/img/post-cover-ex.png";